<template>
  <v-app :class="displayClasses">
    <v-content>
      <router-view />
    </v-content>
  </v-app>
</template>

<script>
import displayMixin from "@/mixins/display";

export default {
  name: "App",
  mixins: [displayMixin],
  data: () => ({
    //
  })
};
</script>
<style lang="scss">
#app {
  font-family: "Open Sans", sans-serif;
  min-width: 250px;
  background-color: white;
  overflow-x: hidden;
}

button {
  &.v-btn{
    border-radius: 23.5px;
    font-size: 13px;
    font-weight: bold;
    letter-spacing: 1.21px;
    &.large{
      border: solid 2px var(--v-primary-base);

      &:not(.v-btn--round).v-size--default {
        height: 47px;
        min-width: 165px;
      }
    }
  }

  &.theme--light.v-btn {
    color: var(--v-primary-base);

    &:not(.v-btn--flat):not(.v-btn--text):not(.v-btn--outlined) {
      background: white;
    }

    &.v-btn--contained {
      box-shadow: #0000001f 0px 17px 16px -12px;
    }
  }
}
</style>
